const state = {
  accountInfo: {},
  partnerGroupDetails: {},
  privacyStatement: '',
  accountUrl: '',
  MetaData: {},

  forcedViewType: '',

  // Geoapify API info
  geoApifyInfo: {},

  // Themes for the header
  themes: [],
  translations: {},
};

const mutations = {
  setAccountInformation(state, accountInfo) {
    state.accountInfo = accountInfo;
  },
  setPartnerGroupDetails(state, partnerGroupDetails) {
    state.partnerGroupDetails = partnerGroupDetails;
  },
  setPrivacyStatement(state, privacyStatement) {
    state.privacyStatement = privacyStatement;
  },
  setAccountUrl(state, accountUrl) {
    state.accountUrl = accountUrl;
  },
  setMetaData(state, metaData) {
    state.MetaData = metaData;
  },
  setForcedViewType(state, viewType) {
    state.forcedViewType = viewType;
  },
  setGeoApifyInfo(state, geoApifyInfo) {
    state.geoApifyInfo = geoApifyInfo;
  },
  setThemes(state, themes) {
    state.themes = [];
    if (themes != null) {
      state.themes = [...themes];
    }
  },
  setTranslations(state, translations) {
    state.translations = translations;
  },
};

const getters = {
  accountInformation(state) {
    return state.accountInfo;
  },
  partnerGroupDetails(state) {
    return state.partnerGroupDetails;
  },
  privacyStatement(state) {
    return state.privacyStatement;
  },
  accountUrl(state) {
    return state.accountUrl;
  },
  metaData(state) {
    return state.MetaData;
  },
  forcedViewType(state) {
    return state.forcedViewType;
  },
  geoApifyInfo(state) {
    return state.geoApifyInfo;
  },
  themes(state) {
    return state.themes;
  },
  mainPartner(state) {
    let mainPartner = {};
    if (
      state.partnerGroupDetails == null ||
      state.partnerGroupDetails.Partners == null
    ) {
      return mainPartner;
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const partner of state.partnerGroupDetails.Partners) {
      if (partner.MainPartner) {
        mainPartner = { ...partner };
        break;
      }
    }
    return mainPartner;
  },
  translations(state) {
    return state.translations;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
